module.exports = __webpack_public_path__ + "media/images/clock-22e3f54edae636c60fab8c03edacdf8c.svg";